import { render, staticRenderFns } from "./PricingModal.vue?vue&type=template&id=0d8775ce"
import script from "./PricingModal.vue?vue&type=script&lang=js"
export * from "./PricingModal.vue?vue&type=script&lang=js"
import style0 from "./PricingModal.vue?vue&type=style&index=0&id=0d8775ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports